module.exports = __webpack_public_path__ + "f980bfbd1effbfb387b55ba3c19a1e61.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/referral/plus.svg
// module id = 1017
// module chunks = 0